import axios from "axios";
import store from "../store/store.js";
import { Message } from "element-ui";
import reporter from '../reporter';
import { formatBlobToEext, isBlobReuqest } from '../common/js/publicUtil'
const JSEncrypt = require('../../static/js/jsencrypt.js');
import { projectInfoConfig } from '@/constant';

const encrypt = new JSEncrypt();
encrypt.setPublicKey('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAx5GOLzQFq2qGBB405U85cnBwP6KcAIbJ8ZjllJVf/6Qxsf5UBzlO7lLEDJ5Td7K/npJSgxUjzduMjZOPw236cvfz244l9OVhwXqU3iQaUUZHxty0dFiMhnJWiV0ml4pXUMQQOv942OBDmuN/aeQLA6CX0E9Sddw6/zhAVttcD0IlAdFMoOErSTpeFtLwiNzI8nFJCjWsHtOtwJDTKCRypySAGwGbKfIUSbW1Q1GK1l+SsR9OQnwd5UM9n0LX17RCXwImD4aPsjhRF+3WWEHkjU6mjSD7zP7ezTeiyGsRe9fepy8OheePtFwMKgfhqmUMd4ZoZSMpgEt3R04xMR+/wwIDAQAB');
axios.defaults.timeout = 1000000;

let uuid = localStorage.getItem('log_uuid');

if (!uuid) {
  uuid = getUuid();
  localStorage.setItem('log_uuid', uuid);
}

function getUuid() {
  const S4 = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}

if (projectInfoConfig && projectInfoConfig.apiPrefix && window.N && window.N.host) {
  window.N.host = window.N.host.replace('/v2-api', val => `${projectInfoConfig.apiPrefix}${val}`);
}

// 请求发出前的拦截器
axios.interceptors.request.use(
  (config) => {
    config.headers = {
      Authorization: window.localStorage.getItem("token"),
      "Content-Type": "application/json",
      _client_uuid: uuid
    };

    if (store.state.vip.enterpriseInfo) {
      config.headers['_w_enterprise_id'] = store.state.vip.enterpriseInfo.id;
    } else if (sessionStorage.getItem('export_enterprise_id')) {
      config.headers['_w_enterprise_id'] = sessionStorage.getItem('export_enterprise_id');
    }

    if (config.url.includes('/v2-api/v1')) {
      config.url = config.url.replace('/v2-api/v1', '/v1');
    }

    if (config.url.includes('/v2-api/v6')) {
      config.url = config.url.replace('/v2-api/v6', '/v6');
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 请求响应数据返回后的拦截器
axios.interceptors.response.use(
  async (response) => {
    let resData = "";
    resData = response.data;

    if (["blob", "arraybuffer"].includes(response.config.responseType)) {
      if (resData.type === 'application/json' && !response.config.url.includes('law/download')) {
        const blobRes = await formatBlobToEext(resData);
        if (blobRes) {
          resData = blobRes;
        } else {
          throw new Error('下载错误，请稍候再试');
        }
      } else {
        if (response.headers['content-disposition']) {
          const fileNameItem = response.headers['content-disposition'].split(';').find(str => str.indexOf('filename=') === 0);
          if (fileNameItem) {
            resData.filename = decodeURIComponent(fileNameItem.slice('filename='.length));
          }
        }
      }
      return resData;
    }

    if (!response.config.url.includes('admin/exception')&&
        !response.config.url.includes('wechat/signature') &&
        resData.statusCode !== 1
      ) {
      reporter.log({ message: resData.message, code: resData.statusCode, requestInfo: response });
    }
    // 请求错误处理
    if (resData.statusCode === 0 || resData.statusCode === 200) {
      // 错误提示
      let msg = resData.message ? resData.message : "请求出错";
      Message({
        message: msg,
        type: "warning",
      });
    }
    if (resData.statusCode === 2) {
      // 超时提示
      let msg = "请求超时，请稍后再试";
      Message({
        message: msg,
        type: "warning",
      });
    }

    if (resData.statusCode === 408) {
      // Message({
      //   message: '您购买的套餐已使用完或到期，请重新购买',
      //   type: 'warning'
      // })
      store.commit("setBuyVip", true);
    }

    if (window.version !== "procuratorate" && window.version !== "guangdianzhongda") {
      if (resData.statusCode == 309) {
        window.localStorage.removeItem("userInfo");
        window.localStorage.removeItem("token");
        window.sessionStorage.setItem('show_logout', resData.message ? resData.message : "您的权限过期，请重新登录");
        window.sessionStorage.setItem('show_login', 1);
        window.location.href = window.location.origin;
        // if (window.version !== "localversion") {
        //   // router.replace({ path: '/main/home' });
        //   store.commit("setPerssion", true);
        // } else {
        //   store.commit("setLocalLogin", true);
        // }
      }

      if (resData.statusCode == 400) {
        store.commit("setFreeTime", true);
      }
    }

    if (window.version == "guangdianzhongda" && resData.statusCode == 309) {
      Message({
        message: '会话过期',
        type: "warning",
      });
    }

    return response;
  },
  (error) => {
    if ((error.message || '').includes('Network Error')) {
      Message({
        message: '网络连接异常，请检查您的网络后再试',
        type: "error",
      });
    } else {
      if (!error.response || !error.response.config.url.includes('admin/exception')) {
        reporter.log({ message: error.message, code: (error.response && error.response.status) || '接口报错连response都没有', requestInfo: error.response || '' });
      }
    }
    Promise.resolve(error);
  }
);

export default {
  uploadfile(url, reqData) {
    url = N.host + url;
    return axios({
      method: "post",
      url,
      data: reqData,
      timeout: 1000000,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  httpPost(url, reqData) {
    if (['user/login','user/valid','wechat/qrCode','wechat/login'].includes(url) && window.sessionStorage.getItem('regUrlkey')) {
      let regUrl = updateQueryStringParameter('regUrl', window.sessionStorage.getItem('regUrlkey'));
      
      if (!reqData) {
        reqData = {};
      }
      reqData.regUrl = regUrl
    }
    if (url === 'user/login' || url === '/user/login') {
      reqData = { encryptData: encrypt.encrypt(JSON.stringify(reqData)) };
    }
    return axios({
      method: "post",
      url: N.host + url,
      data: JSON.stringify(reqData),
      timeout: 1000000,
      headers: {
        "Content-Type": "application/json",
      },
      responseType: isBlobReuqest(url) ? "blob" : "",
    });
  },
  httpGet(url, reqData) {
    if (['user/login','user/valid','wechat/qrCode','wechat/login'].includes(url) && window.sessionStorage.getItem('regUrlkey')) {
      let regUrl = updateQueryStringParameter('regUrl', window.sessionStorage.getItem('regUrlkey'));
      
      if (!reqData) {
        reqData = {};
      }
      reqData.regUrl = regUrl
    }
    return axios({
      method: "get",
      url: N.host + url,
      timeout: 1000000,
      params: reqData,
      responseType: isBlobReuqest(url) ? "blob" : "",
    });
  },
  // 废弃
  httpProxyPost(url, reqData) {
    let sendBody = {
      url: "/" + url,
      method: "POST",
      formParams: null,
      jsonBody: typeof reqData == "string" ? reqData : JSON.stringify(reqData),
    };
    var url = N.host + "admin/send";

    return axios({
      method: "post",
      url: url,
      data: JSON.stringify(sendBody),
      timeout: 1000000,
    });
  },
};

function updateQueryStringParameter(key, value) {
  let url = window.location.href;
	if(!value) {
		return url;
	}
	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	var separator = url.indexOf('?') !== -1 ? "&" : "?";
	if (url.match(re)) {
		return url.replace(re, '$1' + key + "=" + value + '$2');
	}
	else {
		return url + separator + key + "=" + value;
	}
}


// WEBPACK FOOTER //
// ./src/axios/axios.js